<template>
    <div>
        <select-form-group
                :value="value.metric"
                name="metric"
                label="Metric"
                :error="(errors.metric || [])[0]"
                @input="input('metric', $event)"
                :options="metricOptions"
        />
    </div>
</template>

<script>
    import http from '@/http'
    import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'

    export default {
        components: {SelectFormGroup},

        props: {
            value: {
                required: true
            },

            errors: {
                required: true
            }
        },

        computed: {
            metricOptions() {
                return [
                    {value: 'all_articles', label: 'All Articles'},
                    {value: 'news_articles', label: 'News Articles'},
                    {value: 'case_articles', label: 'Case Articles'},
                    {value: 'jobs', label: 'Jobs'},
                    {value: 'events', label: 'Events'}
                ]
            }
        },

        methods: {
            input(key, value) {
                this.$emit('input', {...this.value, [key]: value})
            }
        }
    }
</script>
